import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'userId',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>User ID</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { userId, id } = original.user
        ? original.user
        : { userId: '', id: '' };
      return (
        <div className="d-flex align-items-center">
          <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
            {userId}
          </Link>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'points',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Points</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'waterAmount',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Water Amount</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { waterAmount } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{waterAmount}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'rewardType',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Reward Type</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { rewardType } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{rewardType}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'rewardIdentity',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Reward Identity</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { rewardIdentity } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{rewardIdentity}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'loggedDate',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Logged At</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { loggedDate } = original;
      return (
        <div className="d-flex align-items-center">
          {/* format date */}
          <span className="fw-semibold">
            {moment(loggedDate).format('MM-DD-YYYY h:mm A')}
          </span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  }
];

const NormalPointsRewardTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default NormalPointsRewardTable;
